/** Resolve a displayable avatar URL from API user / activity shapes. */
export function resolveAvatarUrl(source) {
  if (!source || typeof source !== 'object') return ''
  const direct = source.avatarUrl || source.avatar_url || ''
  if (direct) return String(direct)
  const props = source.properties
  if (!props) return ''
  if (typeof props === 'string') {
    try {
      const parsed = JSON.parse(props)
      return parsed?.avatarUrl || parsed?.avatar_url || ''
    } catch {
      return ''
    }
  }
  if (typeof props === 'object') {
    return props.avatarUrl || props.avatar_url || ''
  }
  return ''
}
